import React, { Suspense } from 'react';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';

import FeaturedCategoriesSlider from './FeaturedCategoriesSlider';
import { IMGBASEAPIURL } from '../../config';

const TestimonialsBox = React.lazy(() => import('../Institute/TestimonialsBox'));
const SubscribeBox = React.lazy(() => import('../Institute/SubscribeBox'));
const HomeSlider = React.lazy(() => import('../Institute/HomeSlider'));

const HomeCategory = React.lazy(() => import('../category/HomeCategory'));

const HighlyPopular = React.lazy(() => import('./HighlyPopularCoursesSkills'));
const DownloadApp = React.lazy(() => import('./DownloadApp'));
const WhyAcumen = React.lazy(() => import('./WhyAcumen'));

const PopularCoursesBox = React.lazy(() => import('../Institute/PopularCoursesBox'));

const RequestTeamLearning = React.lazy(() => import('./RequestTeamLearning'));

function DocLearn() {
    return (
        <>
            {/* <Section01 /> */}
            <Suspense fallback={<div className='text-center'><img style={{ maxWidth: '20px', margin: '25px' }} src="/loader.gif" /></div>}>
                <HomeSlider />
            </Suspense>
            {/* <Section02 /> */}
            <Suspense fallback={<div className='text-center'><img style={{ maxWidth: '20px', margin: '25px' }} src="/loader.gif" /></div>}>
                <FeaturedCategoriesSlider />
            </Suspense>
            {/* <Section03 /> */}
            
            <Suspense fallback={<div className='text-center'><img style={{ maxWidth: '20px', margin: '25px' }} src="/loader.gif" /></div>}>
                <div style={{ background: '#f5f5f5' }}>
                    <HomeSlider sectionDesktop="DesktopSecondary" sectionMobile="MobileSecondary" />
                </div>
            </Suspense>
            <Suspense fallback={<div className='text-center'><img style={{ maxWidth: '20px', margin: '25px' }} src="/loader.gif" /></div>}>
                <HomeCategory />
            </Suspense>

            <Suspense fallback={<div></div>}>
                <WhyAcumen />
            </Suspense>

            {/* <Section04 /> */}
            <section className="appie-traffic-area" style={{ paddingBottom: '0px' }}>
                <div className="">
                    <Suspense fallback={<div></div>}>
                        <HighlyPopular />
                    </Suspense>
                </div>
            </section>

            <Suspense fallback={<div></div>}>
                <RequestTeamLearning />
            </Suspense>
            <section
                className="appie-features-area examOriented d-none"
                style={{ padding: '30px 0px 0px 0px' }}
            >
                <div className="container">
                    <Suspense fallback={<div></div>}>
                        <PopularCoursesBox MainCatID="skill" />
                    </Suspense>
                </div>
            </section>
            <Suspense fallback={<div></div>}>
                <TestimonialsBox />
            </Suspense>
            <Suspense fallback={<div></div>}>
                <DownloadApp IMGBASEAPIURL={IMGBASEAPIURL} />
            </Suspense>
            <Suspense fallback={<div></div>}>
                <SubscribeBox />
            </Suspense>
            <Suspense fallback={<div className='text-center'><img style={{ maxWidth: '20px', margin: '25px' }} src="/loader.gif" /></div>}>
                <HomeSlider sectionDesktop="DesktopTrust" sectionMobile="MobileTrust" />
            </Suspense>
            {/* <TrustSliderFooter /> */}
        </>
    );
}

export default DocLearn;
